import { Injectable } from '@angular/core'

import { Observable } from 'rxjs/Observable'
import 'rxjs/add/operator/do'

import { Store } from '@ngrx/store'
import { AppState } from '../reducers'

import { Video } from '../models'
import { VideoApi } from '../apis'
import { PaginatedList } from '../libs/infinite-paginator'
import { SetLectureVideos, SetVideoList, SelectVideo } from '../actions/video'

@Injectable()
export class VideoService {
  constructor(
    private store: Store<AppState>,
    private api: VideoApi,
  ) { }

  loadLectureVideos(lectureId: number): Observable<Video[]> {
    const list = this.api.index(lectureId)
    this.store.dispatch(new SetVideoList(list))

    return list.items.do(l => this.store.dispatch(new SetLectureVideos(lectureId, l)))
  }

  selectVideo(videoId: number): Observable<Video> {
    return this.api.get(videoId).do(v => this.store.dispatch(new SelectVideo(v)))
  }

  update(videoId: number, params: any): Observable<Video> {
    return this.api.update(videoId, params)
      .do(v => this.store.dispatch(new SelectVideo(v)))
  }

  create = this.createYoutubeVideo
  createYoutubeVideo(lectureId: number, name: string, youtubeId: string): Observable<Video> {
    return this.api.create(lectureId, name, youtubeId)
      .do(v => this.store.dispatch(new SelectVideo(v)))
  }

  createNhkVideo(lectureId: number, name: string, dasId: string): Observable<Video> {
    return this.api.createNhkVideo(lectureId, name, dasId)
      .do(v => this.store.dispatch(new SelectVideo(v)))
  }
}



// WEBPACK FOOTER //
// ./src/services/video.ts